import React from 'react'
import { SkipNavLink } from '@reach/skip-nav'
import '@reach/skip-nav/styles.css'

export default () => <SkipNavLink>Skip site navigation</SkipNavLink>
